<template>
    <div class="container-fluid py-3">
        <div class="card shadow-sm">
            <div class="card-header pb-0 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div class="d-flex align-items-center gap-2">
                    <span class="cal-header-icon cal-header-icon--blue">
                        <i class="bi bi-file-earmark-diff-fill"></i>
                    </span>
                    <div>
                        <h6 class="mb-0 fw-bold font-weight-bolder">Təkliflər və ərizələr</h6>
                        <small class="text-muted" style="font-size: 0.78rem;">Sığorta təklifləri və ilkin ərizələrin reyestri</small>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <button type="button" @click="NewQuota()" class="btn action-btn action-btn--success">
                        <i class="bi bi-plus-lg me-1"></i>
                        <span>Yeni ərizə</span>
                    </button>
                    <button type="button" class="btn action-btn action-btn--muted" @click="GetQuotas()">
                        <i class="bi bi-arrow-clockwise me-1"></i>
                        <span>Yeniləmək</span>
                    </button>
                    <button
                        type="button"
                        @click="showFilter = !showFilter"
                        class="btn action-btn"
                        :class="showFilter ? 'action-btn--info' : 'action-btn--muted'"
                        title="Filter"
                    >
                        <i class="bi bi-funnel-fill"></i>
                    </button>
                </div>
            </div>

            <div class="card-body">
                <transition name="slide">
                    <div class="filter-panel-card mb-4 p-3 rounded" v-show="showFilter">
                        <div class="row align-items-end g-3">
                            <div class="col-sm-6 col-md-3 col-lg-2">
                                <label class="form-label mb-1">Status</label>
                                <el-select v-model="status" placeholder="Seçin" class="w-100">
                                    <el-option label="Bütün" :value="-1" />
                                    <el-option label="Qüvvədə olanlar" :value="0" />
                                    <el-option label="Qüvvədən düşmüşlər" :value="1" />
                                    <el-option label="Gözlənilənlər" :value="2" />
                                </el-select>
                            </div>
                            <div class="col-sm-6 col-md-4 col-lg-4">
                                <label class="form-label mb-1">Tarix aralığı</label>
                                <div class="d-flex align-items-center gap-2">
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableStartDate"
                                        v-model="date1" type="date" class="w-50" placeholder="Başlanğıc" />
                                    <el-date-picker format="DD.MM.YYYY" :disabled-date="DisableEndDate"
                                        v-model="date2" type="date" class="w-50" placeholder="Son" />
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-6">
                                <div class="app-search-form-group">
                                    <el-input
                                        v-model="srcText"
                                        placeholder="Tam adı / FIN / Ərizə nömrəsi"
                                        clearable
                                        class="app-search-input"
                                        @keydown.enter="GetQuotas()"
                                    />
                                    <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                        <i class="bi bi-search"></i>
                                        <span>Axtar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div v-loading="loading">
                    <Table @get-data="GetQuotas" :data="data" :showFilter="showFilter"></Table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import Table from "./Components/Table.vue";
export default {
    components: {
        Table
    },
    data() {
        return {
            srcText: null,
            loading: null,
            data: [],
            dialogVis: false,
            status: -1,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewQuota() {
            window.open(window.location.origin + '/documents/quota', "_blank");
        },
        GetQuotas() {
            this.data = [
                {
                    quotaId: 1,
                    quotaFullNumber: "Q-2025-001",
                    statusId: 2,
                    quotaStatusName: "Təstiq olunub",
                    quotaDateStr: "16.08.2025",
                    insured: { name: "ABC Şirkəti" },
                    insuredPerson: { name: "Elvin Əliyev" },
                    insuredCount: 25,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 36,
                    created: "16.08.2025 10:00",
                    updated: "16.08.2025 12:30"
                },
                {
                    quotaId: 2,
                    quotaFullNumber: "Q-2025-002",
                    statusId: 0,
                    quotaStatusName: "Yeni",
                    quotaDateStr: "15.08.2025",
                    insured: { name: "XYZ MMC" },
                    insuredPerson: { name: "Murad Həsənov" },
                    insuredCount: 15,
                    period: 48,
                    payType: "Aylıq",
                    currency: "AZN",
                    created: "15.08.2025 09:20",
                    updated: "15.08.2025 11:45"
                },
                {
                    quotaId: 3,
                    quotaFullNumber: "Q-2025-003",
                    statusId: 3,
                    quotaStatusName: "İmtina olunub",
                    quotaDateStr: "14.08.2025",
                    insured: { name: "Delta Ltd." },
                    insuredPerson: { name: "Leyla Məmmədova" },
                    insuredCount: 40,
                    payType: "Aylıq",
                    currency: "AZN",
                    period: 48,
                    created: "14.08.2025 08:10",
                    updated: "14.08.2025 10:00"
                },
                {
                    quotaId: 4,
                    quotaFullNumber: "Q-2025-004",
                    statusId: 2,
                    quotaStatusName: "Təstiq olunub",
                    quotaDateStr: "13.08.2025",
                    insured: { name: "Gamma Corp." },
                    insuredPerson: { name: "Elvin Bayramov" },
                    insuredCount: 30,
                    period: 36,
                    payType: "Birdəfəlik",
                    currency: "USD",
                    created: "13.08.2025 14:15",
                    updated: "13.08.2025 16:50"
                },
                {
                    quotaId: 5,
                    quotaFullNumber: "Q-2025-005",
                    statusId: 0,
                    quotaStatusName: "Active",
                    quotaDateStr: "12.08.2025",
                    insured: { name: "Beta Holding" },
                    insuredPerson: { name: "Rıza Xanlı" },
                    insuredCount: 50,
                    payType: "Aylıq",
                    currency: "EUR",
                    period: 36,
                    created: "12.08.2025 11:30",
                    updated: "12.08.2025 13:00"
                }
            ];
        }
    },
    mounted() {
        this.GetQuotas()
    }
}
</script>